export default "__VITE_ASSET__COCiKVnI__"